/* eslint-disable import/prefer-default-export */
import useWindowWidth from './useWindowWidth';

export { useWindowWidth };
